import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const BizznetRewardsProgram = () => {
  const navigate = useNavigate();
  const mockUser = null;

  const benefits = [
    {
      id: 1,
      icon: "TrendingUp",
      title: "Comisiones de Dos Niveles",
      description: "Gana dinero de tus referidos directos y de los referidos de tus referidos",
      color: "bg-primary"
    },
    {
      id: 2,
      icon: "Repeat",
      title: "Ingresos Recurrentes",
      description: "Recibe pagos mes tras mes mientras tus referidos mantengan su membresía activa",
      color: "bg-secondary"
    },
    {
      id: 3,
      icon: "Users",
      title: "Red Ilimitada",
      description: "Sin límite de referidos - mientras más compartas, más ganas",
      color: "bg-accent"
    },
    {
      id: 4,
      icon: "Gift",
      title: "Sistema de Puntos",
      description: "Acumula puntos por cada referido y canjea por bonos en efectivo",
      color: "bg-success"
    }
  ];

  const commissionLevels = [
    {
      id: 1,
      level: "Nivel 1",
      percentage: "20%",
      description: "De cada pago mensual de tus referidos directos",
      icon: "UserPlus",
      color: "bg-primary",
      textColor: "text-primary-foreground",
      example: "Si invitas 50 usuarios con plan Emprendedor ($50.000), ganas $500.000 mensuales y lo mejor es que este valor se puede volver recurrente"
    },
    {
      id: 2,
      level: "Nivel 2",
      percentage: "10%",
      description: "De cada pago mensual de los referidos de tus referidos",
      icon: "Users",
      color: "bg-secondary",
      textColor: "text-secondary-foreground",
      example: "Si tus 50 invitados invitan a 10 usuarios más cada uno con el plan Emprendedor ($50.000), ganas $2.500.000 mensuales y lo mejor es que este valor se puede volver recurrente"
    }
  ];

  const howItWorks = [
    {
      id: 1,
      step: "1",
      title: "Regístrate en Bizznet",
      description: "Crea tu cuenta con plan Emprendedor ($50.000/mes) o Elite ($70.000/mes)",
      icon: "UserPlus"
    },
    {
      id: 2,
      step: "2",
      title: "Obtén tu Enlace Único",
      description: "Genera tu enlace de referido personalizado desde tu dashboard",
      icon: "Link"
    },
    {
      id: 3,
      step: "3",
      title: "Comparte tu Enlace",
      description: "Usa redes sociales, WhatsApp, email o cualquier canal digital",
      icon: "Share2"
    },
    {
      id: 4,
      step: "4",
      title: "Gana Comisiones",
      description: "Recibe pagos automáticos cuando tus referidos paguen su membresía",
      icon: "DollarSign"
    }
  ];

  const earningExamples = [
    {
      id: 1,
      scenario: "10 Referidos Directos",
      plan: "Plan Emprendedor ($50.000)",
      nivel1: "$100.000/mes",
      nivel2: "$0",
      total: "$100.000/mes",
      icon: "Users"
    },
    {
      id: 2,
      scenario: "50 Referidos Directos + 500 Nivel 2",
      plan: "Plan Emprendedor ($50.000)",
      nivel1: "$500.000/mes",
      nivel2: "$2.500.000/mes",
      total: "$3.000.000/mes",
      icon: "TrendingUp"
    },
    {
      id: 3,
      scenario: "100 Referidos Directos + 1000 Nivel 2",
      plan: "Plan Elite ($80.000)",
      nivel1: "$1.600.000/mes",
      nivel2: "$8.000.000/mes",
      total: "$9.600.000/mes",
      icon: "Award"
    }
  ];

  const requirements = [
    {
      id: 1,
      requirement: "Plan Emprendedor o Elite Activo",
      description: "Debes mantener tu membresía activa para recibir comisiones",
      icon: "CheckCircle"
    },
    {
      id: 2,
      requirement: "Registro Exitoso de Referidos",
      description: "Tus referidos deben completar su registro y activar su plan",
      icon: "UserCheck"
    },
    {
      id: 3,
      requirement: "Método de Pago Configurado",
      description: "Configura tu billetera digital o cuenta bancaria para retiros",
      icon: "CreditCard"
    }
  ];

  const pointsRewards = [
    {
      id: 1,
      points: "5 puntos",
      action: "Por cada referido exitoso",
      icon: "Award"
    },
    {
      id: 2,
      points: "1.000 puntos",
      reward: "$1.000.000 COP",
      icon: "Gift"
    },
    {
      id: 3,
      minimum: "$200.000 COP",
      action: "Retiro mínimo a billeteras digitales o bancos",
      icon: "Wallet"
    }
  ];

  const withdrawalProcess = [
    {
      id: 1,
      title: "Mínimo de Retiro",
      description: "$200.000 COP acumulados en comisiones",
      icon: "Wallet"
    },
    {
      id: 2,
      title: "Métodos de Pago",
      description: "Nequi, Bancolombia o transferencia bancaria",
      icon: "CreditCard"
    },
    {
      id: 3,
      title: "Tiempo de Procesamiento",
      description: "1-3 días hábiles después de solicitar retiro",
      icon: "Clock"
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Carlos Rodríguez",
      role: "Afiliado desde Marzo 2024",
      testimonial: "En 6 meses he generado una red de 120 referidos. Mis ingresos pasivos mensuales son de $4.500.000 COP. ¡Increíble!",
      earnings: "$4.500.000/mes",
      referrals: "120 referidos",
      image: "/assets/images/no_image.png"
    },
    {
      id: 2,
      name: "María González",
      role: "Afiliada desde Enero 2024",
      testimonial: "Compartí mi enlace en redes sociales y en 3 meses ya tengo 80 referidos. El ingreso recurrente es lo mejor del programa.",
      earnings: "$3.200.000/mes",
      referrals: "80 referidos",
      image: "/assets/images/no_image.png"
    }
  ];

  const faqs = [
    {
      id: 1,
      question: "¿Cuándo recibo mis comisiones?",
      answer: "Las comisiones se calculan automáticamente cada vez que tus referidos pagan su membresía mensual. Puedes solicitar retiro cuando acumules mínimo $200.000 COP."
    },
    {
      id: 2,
      question: "¿Qué pasa si mi referido cancela su plan?",
      answer: "Si un referido cancela su membresía, dejarás de recibir comisiones de ese usuario. Sin embargo, todas las comisiones generadas anteriormente se mantienen en tu cuenta."
    },
    {
      id: 3,
      question: "¿Puedo ser afiliado sin tener plan activo?",
      answer: "No, para participar en el programa de afiliados debes mantener activo tu plan Emprendedor o Elite. Esto garantiza que conoces los beneficios que estás recomendando."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} />
      
      <main>
        {/* Hero Section */}
        <section className="relative py-16 md:py-20 lg:py-24 px-4 sm:px-6 bg-gradient-to-br from-primary via-primary/90 to-secondary text-white overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
              backgroundSize: '40px 40px'
            }} />
          </div>
          
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold mb-6">
                <Icon name="Sparkles" size={20} />
                <span>BIZZNET REWARDS PROGRAM</span>
              </div>
              
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 px-4">
                Gana Dinero Compartiendo Bizznet
              </h1>
              
              <p className="text-lg sm:text-xl md:text-2xl opacity-90 mb-8 max-w-3xl mx-auto px-4">
                Sistema de afiliados de dos niveles con comisiones recurrentes. Construye tu red y genera ingresos pasivos mes tras mes.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Rocket"
                  iconPosition="left"
                  onClick={() => navigate('/user-registration')}
                  className="bg-white text-primary hover:bg-white/90 min-w-[200px]"
                >
                  Comenzar a Referir
                </Button>
                
                <Button
                  variant="outline"
                  size="lg"
                  iconName="PlayCircle"
                  iconPosition="left"
                  onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                  className="border-white text-white hover:bg-white/10 min-w-[200px]"
                >
                  Ver Cómo Funciona
                </Button>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
              {benefits?.map((benefit) => (
                <div
                  key={benefit?.id}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20"
                >
                  <div className={`w-12 h-12 ${benefit?.color} rounded-lg flex items-center justify-center mb-4`}>
                    <Icon name={benefit?.icon} size={24} className="text-white" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{benefit?.title}</h3>
                  <p className="text-sm opacity-80">{benefit?.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Commission Structure */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Sistema de Comisiones de Dos Niveles
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Gana del 20% de tus referidos directos y del 10% de los referidos de tus referidos
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {commissionLevels?.map((level) => (
                <div
                  key={level?.id}
                  className={`${level?.color} ${level?.textColor} rounded-2xl p-8 shadow-xl`}
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                      <Icon name={level?.icon} size={32} />
                    </div>
                    <div>
                      <div className="text-sm font-medium opacity-90">{level?.level}</div>
                      <div className="text-4xl font-bold">{level?.percentage}</div>
                    </div>
                  </div>

                  <p className="text-lg mb-6 opacity-90">
                    {level?.description}
                  </p>

                  <div className="bg-white/10 rounded-xl p-4">
                    <div className="flex items-start gap-2">
                      <Icon name="Calculator" size={20} className="flex-shrink-0 mt-1" />
                      <div>
                        <div className="text-sm font-medium mb-1">Ejemplo de Ganancias:</div>
                        <div className="text-sm opacity-90">{level?.example}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Earning Examples Table */}
            <div className="bg-card rounded-2xl shadow-card p-6 md:p-8">
              <h3 className="text-2xl font-bold text-foreground mb-6 text-center">
                Ejemplos de Ganancias Mensuales
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {earningExamples?.map((example) => (
                  <div
                    key={example?.id}
                    className="bg-muted rounded-xl p-6 border-2 border-border hover:border-primary transition-colors"
                  >
                    <div className="flex items-center justify-center w-12 h-12 bg-primary text-primary-foreground rounded-lg mx-auto mb-4">
                      <Icon name={example?.icon} size={24} />
                    </div>
                    
                    <h4 className="font-bold text-center mb-2">{example?.scenario}</h4>
                    <p className="text-sm text-muted-foreground text-center mb-4">{example?.plan}</p>
                    
                    <div className="space-y-2 mb-4">
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-muted-foreground">Nivel 1:</span>
                        <span className="font-semibold text-primary">{example?.nivel1}</span>
                      </div>
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-muted-foreground">Nivel 2:</span>
                        <span className="font-semibold text-secondary">{example?.nivel2}</span>
                      </div>
                      <div className="border-t border-border pt-2 flex justify-between items-center">
                        <span className="font-bold">Total:</span>
                        <span className="font-bold text-lg text-success">{example?.total}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section id="how-it-works" className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                ¿Cómo Funciona el Programa?
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Cuatro pasos simples para empezar a ganar dinero con Bizznet Rewards
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {howItWorks?.map((step, index) => (
                <div key={step?.id} className="relative">
                  <div className="bg-card rounded-xl p-6 shadow-card h-full">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold text-lg">
                        {step?.step}
                      </div>
                      <Icon name={step?.icon} size={24} className="text-primary" />
                    </div>
                    
                    <h3 className="text-lg font-bold mb-2">{step?.title}</h3>
                    <p className="text-sm text-muted-foreground">{step?.description}</p>
                  </div>
                  
                  {index < howItWorks?.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                      <Icon name="ArrowRight" size={24} className="text-muted-foreground" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Requirements */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Requisitos para Participar
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Lo que necesitas para ser parte del programa de afiliados de Bizznet
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {requirements?.map((req) => (
                <div
                  key={req?.id}
                  className="bg-card rounded-xl p-6 shadow-card"
                >
                  <div className="w-12 h-12 bg-success/10 text-success rounded-lg flex items-center justify-center mb-4">
                    <Icon name={req?.icon} size={24} />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{req?.requirement}</h3>
                  <p className="text-sm text-muted-foreground">{req?.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Points System */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Sistema de Puntos Bizznet
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Acumula puntos por cada referido y gana bonos especiales en efectivo
              </p>
            </div>

            <div className="bg-card rounded-xl sm:rounded-2xl shadow-card p-5 sm:p-6 md:p-7 lg:p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-foreground text-center mb-5 sm:mb-6 md:mb-7 lg:mb-8 px-2">
                Sistema de Puntos y Recompensas
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
                {pointsRewards?.map((reward) => (
                  <div
                    key={reward?.id}
                    className="bg-muted rounded-lg sm:rounded-xl p-4 sm:p-5 md:p-6 text-center"
                  >
                    <div className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12 bg-primary text-primary-foreground rounded-lg mx-auto mb-3 sm:mb-3.5 md:mb-4">
                      <Icon name={reward?.icon} size={20} className="sm:hidden" />
                      <Icon name={reward?.icon} size={22} className="hidden sm:block md:hidden" />
                      <Icon name={reward?.icon} size={24} className="hidden md:block" />
                    </div>
                    {reward?.points && (
                      <div className="text-xl sm:text-2xl font-bold text-primary mb-1.5 sm:mb-2">
                        {reward?.points}
                      </div>
                    )}
                    {reward?.reward && (
                      <div className="text-xl sm:text-2xl font-bold text-success mb-1.5 sm:mb-2">
                        {reward?.reward}
                      </div>
                    )}
                    {reward?.minimum && (
                      <div className="text-xl sm:text-2xl font-bold text-foreground mb-1.5 sm:mb-2">
                        {reward?.minimum}
                      </div>
                    )}
                    <p className="text-xs sm:text-sm text-muted-foreground">
                      {reward?.action}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Withdrawal Process */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Proceso de Retiro de Comisiones
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Retira tus ganancias de forma fácil y segura
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {withdrawalProcess?.map((process) => (
                <div
                  key={process?.id}
                  className="bg-card rounded-xl p-6 shadow-card"
                >
                  <div className="w-12 h-12 bg-accent/10 text-accent rounded-lg flex items-center justify-center mb-4">
                    <Icon name={process?.icon} size={24} />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{process?.title}</h3>
                  <p className="text-sm text-muted-foreground">{process?.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 bg-gradient-to-r from-primary to-secondary text-white rounded-2xl p-6 md:p-8 text-center">
              <Icon name="Info" size={32} className="mx-auto mb-4" />
              <h3 className="text-xl md:text-2xl font-bold mb-3">
                Nota Importante sobre Retiros
              </h3>
              <p className="text-sm md:text-base opacity-90 max-w-2xl mx-auto">
                En el momento de procesar y solicitar un retiro recuerda configurar de manera correcta los datos de tu opcion de pago, si hay errores en los datos, retrazaras el proceso de pago.
              </p>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Historias de Éxito
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Conoce a algunos de nuestros afiliados más exitosos
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {testimonials?.map((testimonial) => (
                <div
                  key={testimonial?.id}
                  className="bg-card rounded-xl p-6 md:p-8 shadow-card"
                >
                  <div className="flex items-start gap-4 mb-4">
                    <img
                      src={testimonial?.image}
                      alt={`Foto de perfil de ${testimonial?.name}, afiliado exitoso de Bizznet Rewards`}
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    <div>
                      <h3 className="font-bold text-lg">{testimonial?.name}</h3>
                      <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                    </div>
                  </div>

                  <p className="text-muted-foreground mb-4 italic">
                    "{testimonial?.testimonial}"
                  </p>

                  <div className="flex gap-4 pt-4 border-t border-border">
                    <div className="flex items-center gap-2">
                      <Icon name="DollarSign" size={18} className="text-success" />
                      <span className="text-sm font-semibold">{testimonial?.earnings}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon name="Users" size={18} className="text-primary" />
                      <span className="text-sm font-semibold">{testimonial?.referrals}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Preguntas Frecuentes
              </h2>
              <p className="text-lg text-muted-foreground">
                Resuelve tus dudas sobre el programa de afiliados
              </p>
            </div>

            <div className="space-y-4">
              {faqs?.map((faq) => (
                <div
                  key={faq?.id}
                  className="bg-card rounded-xl p-6 shadow-card"
                >
                  <div className="flex items-start gap-3 mb-3">
                    <Icon name="HelpCircle" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <h3 className="font-bold text-lg">{faq?.question}</h3>
                  </div>
                  <p className="text-muted-foreground text-sm pl-8">
                    {faq?.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-gradient-to-r from-primary to-secondary text-white">
          <div className="max-w-4xl mx-auto text-center">
            <Icon name="Rocket" size={48} className="mx-auto mb-6" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              ¿Listo para Empezar a Ganar?
            </h2>
            <p className="text-lg md:text-xl opacity-90 mb-8 max-w-2xl mx-auto">
              Únete a cientos de afiliados que ya están generando ingresos pasivos compartiendo Bizznet. 
              Regístrate hoy y obtén tu enlace de referido personalizado.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="default"
                size="lg"
                iconName="UserPlus"
                iconPosition="left"
                onClick={() => navigate('/user-registration')}
                className="bg-white text-primary hover:bg-white/90 min-w-[220px]"
              >
                Registrarme Ahora
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={() => window.open('https://wa.me/573152495959', '_blank')}
                className="border-white text-white hover:bg-white/10 min-w-[220px]"
              >
                Hablar con Soporte
              </Button>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-1">20%</div>
                <div className="text-sm opacity-80">Comisión Nivel 1</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-1">10%</div>
                <div className="text-sm opacity-80">Comisión Nivel 2</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-1">∞</div>
                <div className="text-sm opacity-80">Referidos Ilimitados</div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-card border-t border-border py-6 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm text-muted-foreground">
            © 2024 BIZZNET. Todos los derechos reservados. | 
            <a href="/terms-and-conditions" className="hover:text-primary ml-2">Términos</a> | 
            <a href="/privacy-policy" className="hover:text-primary ml-2">Privacidad</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BizznetRewardsProgram;